export const depotColours = [
  "rgb(100, 100, 200)",
  "rgb(252, 169, 100)",
  "rgb(250,255,199)",
  "rgb(208, 208, 254)",
  "rgb(169, 252, 150)",
  "rgb(70, 189, 169)",
  "rgb(160, 173, 252)",
  "rgb(198, 252, 169)",
  "rgb(224, 255, 253)",
  "rgb(150, 169, 222)",
  "rgb(169, 247, 252)",
  "rgb(252, 234, 169)",
  "rgb(109, 200, 252)",
  "rgb(255, 191, 129)",
  "rgb(167, 192, 207)",
  "rgb(237, 169, 252)",
  "rgb(200, 200, 100)",
  "rgb(15, 169, 150)",
  "rgb(252, 150, 100)",
  "rgb(169, 252, 230)",
  "rgb(226, 252, 169)",
  "rgb(2, 207, 200)",
  "rgb(188, 217, 218)",
  "rgb(180, 252, 169)",
  "rgb(169, 229, 252)",
  "rgb(182, 169, 252)",
  "rgb(100, 200, 150)",
  "rgb(252, 251, 169)",
  "rgb(169, 220, 202)",
  "rgb(227, 169, 252)",
  "rgb(252, 179, 169)",
  "rgb(224, 187, 228)",
  "rgb(169, 184, 252)",
  "rgb(209, 252, 169)",
  "rgb(252, 169, 233)",
  "rgb(169, 252, 247)",
  "rgb(252, 223, 169)",
  "rgb(250, 200, 100)",
  "rgb(147, 200, 190)",
  "rgb(169, 252, 175)",
  "rgb(244, 169, 100)",
  "rgb(169, 212, 252)",
  "rgb(237, 252, 169)",
  "rgb(250, 100, 100)",
  "rgb(169, 201, 252)",
  "rgb(252, 196, 169)",
  "rgb(100, 252, 219)",
  "rgb(100, 102, 169)",
  "rgb(252, 240, 169)",
  "rgb(169, 240, 252)",
  "rgb(100, 202, 037)",
  "rgb(200, 252, 191)",
  "rgb(20, 130, 200)",
  "rgb(169, 196, 252)",
  "rgb(205, 99, 100)",
  "rgb(21, 205, 160)",
  "rgb(200, 150, 100)",
  "rgb(184, 252, 169)",
  "rgb(152, 100, 116)",
  "rgb(189, 169, 252)",
  "rgb(252, 169, 198)",
  "rgb(169, 223, 252)",
  "rgb(252, 212, 169)",
  "rgb(247, 252, 169)",
  "rgb(100, 102, 169)",
  "rgb(160, 232, 209)",
  "rgb(100, 50, 152)",
  "rgb(252, 184, 169)",
  "rgb(169, 177, 252)",
  "rgb(202, 200, 169)",
  "rgb(252, 169, 226)",
  "rgb(169, 251, 252)",
  "rgb(252, 230, 169)",
  "rgb(205, 169, 252)",
  "rgb(42, 252, 182)",
  "rgb(252, 169, 182)",
  "rgb(169, 205, 252)",
  "rgb(230, 252, 169)",
  "rgb(155, 246, 255)",
  "rgb(255, 100, 209)",
  "rgb(251, 169, 252)",
  "rgb(169, 205, 226)",
  "rgb(252, 202, 100)",
  "rgb(208, 244, 222)",
  "rgb(177, 169, 252)",
  "rgb(20, 109, 209)",
  "rgb(169, 233, 252)",
  "rgb(252, 247, 169)",
  "rgb(169, 252, 198)",
  "rgb(223, 100, 50)",
  "rgb(169, 189, 252)",
  "rgb(252, 250, 169)",
  "rgb(252, 169, 237)",
  "rgb(212, 202, 169)",
  "rgb(169, 252, 244)",
  "rgb(20, 219, 169)",
  "rgb(196, 169, 252)",
  "rgb(169, 120, 071)",
  "rgb(224, 187, 228)",
  "rgb(2, 169, 191)",
  "rgb(169, 216, 252)",
  "rgb(240, 252, 169)",
  "rgb(255, 173, 173)",
  "rgb(240, 169, 252)",
  "rgb(169, 252, 215)",
  "rgb(252, 191, 169)",
  "rgb(169, 172, 252)",
];
